// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { configureBudgetStyles } from "@eisinc/Overrides/Widgets/Budget/ConfigureBudget";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

configureBudgetStyles.cancelButton = { variant: "secondary" };

configureBudgetStyles.enforcementLevelLabel = {
    variant: "h5",
    css: css`
        display: inline-block;
        margin-right: 6px;
        margin-bottom: 0;
    `,
};

configureBudgetStyles.budgetYearEndGridItem = {
    width: 12,
    css: css`
        align-items: flex-end;
    `,
};

configureBudgetStyles.budgetYearEndDatePicker = {
    cssOverrides: {
        formField: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: auto;
                        margin-right: 35px;
                        margin-top: 15px;
                    `,
                    css`
                        width: auto;
                        margin-right: 35px;
                        margin-top: 15px;
                    `,
                    css`
                        width: auto;
                        margin-right: 35px;
                    `,
                    css`
                        width: auto;
                        margin-right: 35px;
                    `,
                    css`
                        width: auto;
                        margin-right: 35px;
                    `,
                ])}

            @media (max-width: 1023px) and (min-width: 769px) {
                margin-top: 20px;
            }
        `,
        formInputWrapper: css`
            margin-top: 10px !important;
        `,
    },
    labelProps: {
        css: css`
            margin-bottom: 3px;
        `,
    },
};

configureBudgetStyles.customBudgetPeriodInput = {
    type: "number",
    min: 1,
    max: 13,
    cssOverrides: {
        formField: css`
            width: 55px;
            display: inline-block !important;
            margin-right: 20px;
        `,
        formInputWrapper: css`
            margin: 0;
        `,
        inputSelect: css`
            padding-right: 5px;
            &:focus {
                padding-right: 5px;
            }
        `,
    },
};
